import * as React from 'react';
import { SvgIcon, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import IconMail from '@mui/icons-material/Mail';
import IconPhone from '@mui/icons-material/Phone';
import IconSmartphone from '@mui/icons-material/Smartphone';
import IconStreet from '@mui/icons-material/PinDrop';
import IconCity from '@mui/icons-material/Domain';
import Customer from 'features/riesterProfiCheck/customers/domain/Customer';

interface InfoRowProps {
    icon: React.ElementType;
    title: string;
    value?: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ icon, title, value }) => {
    return (
        <TableRow>
            <TableCell style={{ borderBottom: 'none', width: '10%' }}>
                <SvgIcon style={{ color: grey[600] }} component={icon} />
            </TableCell>
            <TableCell style={{ borderBottom: 'none', width: '20%' }}>
                <Typography variant={'body1'}>{title}</Typography>
            </TableCell>
            <TableCell style={{ borderBottom: 'none' }}>
                <Typography variant={'body1'}>{value}</Typography>
            </TableCell>
        </TableRow>
    );
};
interface CustomerDataViewProps {
    customer: Customer;
}

const CustomerDataView: React.FC<CustomerDataViewProps> = ({ customer }) => {
    return (
        <Table style={{ marginTop: '12px' }}>
            <TableBody>
                <InfoRow icon={IconMail} title={'E-Mail Addresse'} value={customer.email} />
                <InfoRow icon={IconPhone} title={'Telefon'} value={customer.address?.phone} />
                <InfoRow icon={IconStreet} title={'Straße'} value={customer.address?.streetAndNumber} />
                <InfoRow icon={IconCity} title={'PLZ Stadt'} value={customer.cityWithPostalCode} />
            </TableBody>
        </Table>
    );
};

export default CustomerDataView;
